// extracted by mini-css-extract-plugin
module.exports = {"timerElapsed":"styles_timerElapsed__3MdOq"};